import React from 'react';
import { DialogContent, DialogContentProps, DialogContentClassKey, ClassNameMap } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useModalContext } from './modal.context';


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
    padding: theme.spacing(3, 3),
    flex: 1,
    flexDirection: 'column',
    width: '100%',
  },
  rootDisabled: {
    opacity: 0.7,
    userSelect: 'none',
    pointerEvents: 'none',
  },
  noPadding: {
    padding: '0 !important',
  },
}));


export type ModalContentProps = DialogContentProps & {
  classes?: Partial<ClassNameMap<DialogContentClassKey> & ReturnType<typeof useStyles>['classes']>;
  disabled?: boolean;
  noPadding?: boolean;
};


export const ModalContent: React.FC<ModalContentProps> = ({ classes: _classes, noPadding, children, className, ...props }) => {
  const {
    cx,
    classes: {
      rootDisabled,
      noPadding: noPaddingClassName,
      ...restClasses
    }
  } = useStyles(undefined, {
    props: {
      classes: _classes
    }
  });
  const modalContext = useModalContext();
  const _disabled = modalContext.loading || modalContext.disabled || props.disabled;

  return (
    <DialogContent
      classes={restClasses}
      className={cx(className, {
        [rootDisabled]: _disabled,
        [noPaddingClassName]: noPadding,
      })}
      {...props}
    >
      {children}
    </DialogContent>
  );
};
